// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2779": "1e66b693bc90","5400": "50ceaf1115bf","6863": "454c9f289029","7535": "ebe468455687","8357": "dd422574e14d",}[chunkId] + ".css"
}